<template>
  <div class="bienvenida-page">
    <p class="versiculo-referencia-fija" ref="versiculoRef">JADE CHÁVEZ</p>

    <!-- Contenedor fecha -->
    <div class="fecha-evento" ref="fechaRef">
      <p class="fecha-gran-dia" ref="granDiaRef">Save the Date</p>
      <p class="fecha-dia-semana" ref="diaSemanaRef">Sábado</p>
      <p class="fecha-dia-numero" ref="numeroRef">05</p>
      <p class="fecha-mes" ref="mesRef">DICIEMBRE</p>
      <p class="fecha-anio" ref="anioRef">2026</p>
    </div>

    <!-- Contenido principal -->
   
    <!-- Contenido principal -->
    <div class="bienvenida-container">
      <div class="contenido-bienvenida">
        <div class="mensaje-bienvenida" ref="mensajeRef">
          {{ mensaje }}
        </div>
       <div class="versiculo-container" ref="versiculoTextRef">
          <p class="versiculo-texto">
          Hace&nbsp; <span class="letra-quince"> 15 años</span> comenzó mi historia, un viaje lleno de risas, aprendizajes y sueños compartidos.
<br><br>

Hoy, ese camino me trae hasta aquí, a este día tan especial donde celebro no solo mi vida, sino también el amor de quienes han estado conmigo en cada paso.
<br>
<br>

Esta invitación es una ventana a mi corazón, y me emociona que estés aquí para acompañarme.
Bienvenidos a un capítulo inolvidable de este cuento que apenas comienza.<br>
      </p>
        </div>
      </div>
    </div>

    <!-- Mariposa 1 (Arriba derecha) -->
    <div class="disco-group mari1-group">
      <img src="@/assets/mari.png" alt="mariposa" class="disco mariposa-fina" ref="disco1Ref" />
    </div>

    <!-- Mariposa 2 (Centro izquierda) -->
    <div class="disco-group mari2-group">
      <img src="@/assets/mari.png" alt="mariposa" class="disco mariposa-fina" ref="disco2Ref" />
    </div>

    <!-- Grupo decorativo 3 (Moño + Estrella) -->
    <div class="disco-group disco3-group">
      <img src="@/assets/estrella.avif" alt="estrellas" class="estrellas" ref="estrella3Ref" />
      <img src="@/assets/moñii.png" alt="disco" class="disco" ref="disco3Ref" />
    </div>

   

    <!-- Mariposa 5 (Inferior izquierda) -->
    <div class="disco-group mari5-group">
      <img src="@/assets/mari.png" alt="mariposa" class="disco mariposa-fina" ref="mari5Ref" />
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'BienvenidaPage',
  setup() {
    const mensaje = ref('');

    const granDiaRef = ref(null);
    const diaSemanaRef = ref(null);
    const numeroRef = ref(null);
    const mesRef = ref(null);
    const anioRef = ref(null);
    const mensajeRef = ref(null);
    const versiculoTextRef = ref(null);
    const versiculoRef = ref(null);

    // Referencias mariposas y elementos
    const disco1Ref = ref(null);
    const disco2Ref = ref(null);
    const disco3Ref = ref(null);
    const mari3Ref = ref(null);
    const mari4Ref = ref(null);
    const mari5Ref = ref(null);

    const estrella1Ref = ref(null);
    const estrella2Ref = ref(null);
    const estrella3Ref = ref(null);

    const animateOnScroll = (el, animationFn) => {
      if (!el) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            animationFn();
            observer.unobserve(el);
          }
        },
        { threshold: 0.3 }
      );
      observer.observe(el);
    };

    onMounted(() => {
      // Entradas de texto
      animateOnScroll(granDiaRef.value, () =>
        gsap.fromTo(granDiaRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1.2, ease: 'power2.out' })
      );
      animateOnScroll(diaSemanaRef.value, () =>
        gsap.fromTo(diaSemanaRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1.2, ease: 'power2.out' })
      );
      animateOnScroll(numeroRef.value, () =>
        gsap.fromTo(numeroRef.value, { opacity: 0, y: -40, scale: 0.9 }, { opacity: 1, y: 0, scale: 1, duration: 1.4, ease: 'back.out(1.2)' })
      );
      animateOnScroll(mesRef.value, () =>
        gsap.fromTo(mesRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1.2, delay: 0.2, ease: 'power2.out' })
      );
      animateOnScroll(anioRef.value, () =>
        gsap.fromTo(anioRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1.2, delay: 0.3, ease: 'power2.out' })
      );
      animateOnScroll(mensajeRef.value, () =>
        gsap.fromTo(mensajeRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1.4, ease: 'power2.out' })
      );
      animateOnScroll(versiculoTextRef.value, () =>
        gsap.fromTo(versiculoTextRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1.4, ease: 'power2.out' })
      );
      animateOnScroll(versiculoRef.value, () =>
        gsap.fromTo(versiculoRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1.2, ease: 'power2.out' })
      );

      // Animación de aleteo fino, sutil y orgánico (sin desplazarse)
      const animarMariposaFina = (el, speed = 0.6, delay = 0) => {
        if (!el) return;
        
        // 1. Aparición ultra suave
        gsap.fromTo(
          el,
          { opacity: 0, scale: 0.7 },
          {
            opacity: 1,
            scale: 1,
            duration: 1.5,
            delay: delay,
            ease: "power2.out",
            onComplete: () => {
              // 2. Aleteo delicado y elegante mediante compresion lateral + leve balanceo
              const tl = gsap.timeline({ repeat: -1, yoyo: true });
              tl.to(el, {
                scaleX: 0.72,
                scaleY: 1.05,
                rotation: "+=4",
                duration: speed,
                ease: "sine.inOut"
              });
            }
          }
        );
      };

      // Animación Moño + Estrella
      const animateDiscoConEstrella = (discoEl, estrellaEl, delay = 0) => {
        if (!discoEl) return;
        const tl = gsap.timeline({ delay });

        tl.fromTo(
          discoEl,
          { opacity: 0, scale: 0.8 },
          { opacity: 1, scale: 1, duration: 1.2, ease: "power2.out" }
        );

        if (estrellaEl) {
          tl.fromTo(
            estrellaEl,
            { opacity: 0, scale: 0.5 },
            { opacity: 1, scale: 1, duration: 1, ease: "back.out(1.5)" },
            "-=0.6"
          );
        }
      };

      // Ejecución de las 5 mariposas con ritmos y retardos desfasados
      animateOnScroll(disco1Ref.value, () => animarMariposaFina(disco1Ref.value, 0.55, 0));
      animateOnScroll(disco2Ref.value, () => animarMariposaFina(disco2Ref.value, 0.65, 0.15));
      animateOnScroll(mari3Ref.value, () => animarMariposaFina(mari3Ref.value, 0.5, 0.25));
      animateOnScroll(mari4Ref.value, () => animarMariposaFina(mari4Ref.value, 0.7, 0.35));
      animateOnScroll(mari5Ref.value, () => animarMariposaFina(mari5Ref.value, 0.58, 0.45));

      // Moño + estrella
      animateOnScroll(disco3Ref.value, () => animateDiscoConEstrella(disco3Ref.value, estrella3Ref.value, 0.3));
    });

    return {
      mensaje,
      granDiaRef,
      diaSemanaRef,
      numeroRef,
      mesRef,
      anioRef,
      mensajeRef,
      versiculoTextRef,
      versiculoRef,
      disco1Ref,
      disco2Ref,
      disco3Ref,
      mari3Ref,
      mari4Ref,
      mari5Ref,
      estrella1Ref,
      estrella2Ref,
      estrella3Ref
    };
  }
};
</script>

<style scoped>
.bienvenida-page {
  background:#f3f7fd;
  color: black;
  min-height: 100vh;
  padding: 0px 20px;
  margin-bottom: 5px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

/* Fecha */
.fecha-evento {
  text-align: center;
  margin: 60px 0 40px;
  color:#043b73;
}
.fecha-gran-dia {
  font-family: 'titulos', cursive;
  font-size: 66px;
  margin: 0;
}
.fecha-dia-semana {
  font-family: 'fecha', serif;
  font-size: 29px;
  margin: 10px 0;
}
.fecha-dia-numero {
  font-family: 'fecha', serif;
  font-size: 72px !important;
  font-weight: bold;
  margin: 0;
}
.fecha-mes {
  font-family: 'Playfair Display', serif;
  font-size: 26px;
  font-weight: 600;
  margin-top: 5px;
  letter-spacing: 2px;
}
.fecha-anio {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-style: italic;
  margin-top: 5px;
}

/* Contenido */
.bienvenida-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mensaje-bienvenida {
  font: 300 19px 'Josefin Sans', sans-serif;
  color: #000;
  white-space: pre-line;
  text-align: center;
  line-height: 2;
  opacity: 0;
}
.versiculo-container {
  margin: 30px 20px 0 20px;
  text-align: center;
  opacity: 0;
}
.versiculo-texto {
  font: 18px 'quote', sans-serif;
  line-height: 1.8;
  color: #333;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.versiculo-referencia-fija {
  font: 24px 'nombre', sans-serif;
  color: #070707;
  margin-top: 40px;
  opacity: 0;
}
.letra-quince {
  font-family: 'british', cursive;
  font-size: 25px;
  color: #043b73;
  letter-spacing: 1px;
}

.letra-quince1 {
  font-family: 'british', cursive;
  font-size: 19px;
  color: #000;
  letter-spacing: 1px;
}

/* Elementos decorativos */
.disco-group {
  position: absolute;
  opacity: 1;
  pointer-events: none;
  z-index: 2;
}
.disco {
  width: 65px !important;
  display: block;
}
.mariposa-fina {
  transform-origin: center center;
  filter: drop-shadow(0px 4px 6px rgba(4, 59, 115, 0.08));
}
.estrellas {
  width: 100px;
  position: absolute;
  bottom: -35px;
  left: 0;
  transform: rotate(-10deg);
  opacity: 0;
}

/* Posiciones centradas y rotaciones individuales */
.mari1-group {
  top: 2%;
  right: 5%;
  transform: rotate(14deg);
}
.mari2-group {
  top: 28%;
  left: 4%;
  transform: rotate(-18deg);
}
.mari3-group {
  top: 98%;
  right: 2%;
  transform: rotate(10deg);
}
.mari4-group {
  bottom: 20%;
  right: 8%;
  width:0px !important;
  transform: rotate(-12deg);
}
.mari5-group {
  bottom: 8%;  width:0px !important;

  left: 5%;opacity: 0 !important;
  transform: rotate(22deg);
}
.disco3-group {width:0px !important;
  bottom: -10%;opacity: 0 !important;
  left: 2%;
  z-index: 10;
}
</style>